var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHelpTipExpand = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 8,
  viewBox: "0 0 15 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0.349609 0.147461L7.34961 7.14746L14.3496 0.147461H0.349609Z",
  fill: "#D2DDEC"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHelpTipExpand);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/helpTipExpand.21b9f291923327a9566c6f8b6fa58f01.svg";